import {useAuthStore} from "../store/auth.store";
import {useEffect, useState} from "react";
import {useEventsStore} from "../store/events.store";
import {useEvents} from "../hook/partner/events.partner.hook";
import {PartnerApi} from "../api/partner.api";
import {NavLink} from "react-router";
import {useBreadcrumbsStore} from "../store/breadcrumbs.store";
import { useTranslation } from "../hooks/useTranslation";

function Events() {
    const { t } = useTranslation();
    const eventsMutation = useEvents();
    const [page, setPage] = useState(null);
    const [vendor, setVendor] = useState(null);
    const [vendors, setVendors] = useState([]);
    const [kind, setKind] = useState(null);
    const [kinds, setKinds] = useState([]);
    const [months, setMonths] = useState({});

    const token = useAuthStore((state) => state.token);
    const events = useEventsStore((state) => state.events);

    const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
    const setPagename = useBreadcrumbsStore((state) => state.setPagename);
    useEffect(() => {
        setPagename(t("events.calendar"));
        setBreadcrumbs([]);
    }, []);


    useEffect(() => {
        if (token) {
            eventsMutation.mutate(
                {
                    token, data: {
                        filter: {}
                    }
                }
            )
        }
    }, [token]);

    useEffect(() => {
        if (events?.length > 0) {
            let months = {};
            let kinds = [];
            let vendors = [];
            let settedPage = false;
            events.forEach((event) => {
                months[event.month] = event.monthName;
                if (event.vendor?.length > 0) {
                    if (!vendors.includes(event.vendor[0].name)) {
                        vendors.push(event.vendor[0].name);
                    }
                }
                if (event.event_kind?.length > 0) {
                    if (!kinds.includes(event.event_kind[0].description)) {
                        kinds.push(event.event_kind[0].description);
                    }
                }

                if (!page && settedPage === false) {
                    // setPage(event.month);
                    settedPage = true;
                }
            })
            
            setMonths(months);
            setVendors(vendors.sort());
            setKinds(kinds.sort());
        }
    }, [events]);

    const eventFiltered = events?.filter(event => {
        if (!vendor && !kind) {
            return true;
        }

        if (!kind && vendor && event.vendor?.length > 0 && event.vendor[0].name === vendor) {
            return true;
        }

        if (!vendor && kind && event.event_kind?.length > 0 && event.event_kind[0].description === kind) {
            return true;
        }

        if (vendor && event.vendor?.length > 0 && event.vendor[0].name === vendor
            && kind && event.event_kind?.length > 0 && event.event_kind[0].description === kind) {
            return true;
        }

        return false;
    });

    return (
        <>
            {events?.length > 0 ? (
                <div className="row">
                    <div className="col-md-9">
                        {Object.keys(months)?.length > 0 && (
                            <ul className="mb-5 nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">

                                <li className="nav-item">
                                        <span onClick={() => setPage(null)}
                                              className={"cursor-pointer nav-link" + (page == null ? " active" : "")}
                                              aria-current="page"
                                        >
                                            {t("common.all")}
                                        </span>
                                </li>

                                {Object.keys(months).map((month) => (
                                    <li className="nav-item">
                                        <span onClick={() => setPage(month)}
                                              className={"cursor-pointer nav-link" + (page == month ? " active" : "")}
                                              aria-current="page"
                                        >
                                            {months[month]}
                                        </span>
                                    </li>
                                ))}

                            </ul>
                        )}

                        {eventFiltered?.map((event, event_key) => (
                            ((page!== null && event.month === page) || (page===null)) && (
                                <div key={event_key}
                                     className={"card p-5 mb-10"}>
                                    <div className="row">
                                        <div className="col-12 col-sm-6 col-md-3 p-5">
                                            <NavLink to={`/akce/${event.event_id}`}>
                                            {event.vendor?.length > 0 && (
                                                    <img className="mw-100"
                                                         style={{
                                                             aspectRatio: '1 / 1',
                                                             objectFit: 'contain',
                                                         }}
                                                         src={PartnerApi.url + '/vendor/' + event.vendor[0].vendor_id + '/logo.jpg'}
                                                         alt={event.name}/>
                                                )}
                                            </NavLink>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-9 p-5">
                                            <h2 className="mb-4">{event.name}</h2>
                                            <div className="mb-2">
                                        <span className="ki-duotone ki-map"><span className="path1"></span><span
                                            className="path2"></span></span>&nbsp;
                                                {event.location}
                                            </div>
                                            <div className="mb-6">
                                        <span className="ki-duotone ki-time"><span className="path1"></span><span
                                            className="path2"></span></span>&nbsp;
                                                {event.sameDay ? (
                                                    <>
                                                        {(new Date(event.date_start)).toLocaleDateString()}&nbsp;
                                                        {(new Date(event.date_start)).toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        })}&nbsp;-&nbsp;
                                                        {(new Date(event.date_end)).toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        })}
                                                    </>
                                                ) : (
                                                    <>
                                                        {(new Date(event.date_start)).toLocaleDateString()}&nbsp;
                                                        {(new Date(event.date_start)).toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        })}&nbsp;
                                                        -&nbsp;
                                                        {(new Date(event.date_end)).toLocaleDateString()}&nbsp;
                                                        {(new Date(event.date_end)).toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        })}
                                                    </>
                                                )}
                                            </div>
                                            <p>

                                                <a href={event.registration_url} target="_blank"
                                                   rel="noopener noreferrer"
                                                   className="btn btn-sm btn-primary me-4">{t("events.register")}</a>
                                                <NavLink to={`/akce/${event.event_id}`}
                                                         className="btn btn-sm btn-secondary">
                                                    {t("events.moreInfo")}
                                                </NavLink>
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            )
                        ))}
                    </div>
                    <div className="col-md-3">
                        <h2>{t("deals.vendor")}</h2>

                        <div className="mb-10 menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
                            {vendors?.length > 0 && (
                                vendors?.map((vendorI) => (
                                    <div className="menu-item" key={vendorI}>
                                        <span
                                            onClick={() => vendorI === vendor ? setVendor(null) : setVendor(vendorI)}
                                            className={"cursor-pointer menu-link " + (vendorI === vendor ? "active" : "")}
                                        >
                                            {vendorI}
                                        </span>
                                    </div>
                                ))
                            )}
                        </div>
                        {/*<h2>Typ akce</h2>

                        <div className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
                            {kinds?.length > 0 && (
                                kinds?.map((kindI) => (
                                    <div className="menu-item" key={kindI}>
                                        <span
                                            onClick={() => kindI === kind ? setKind(null) : setKind(kindI)}
                                            className={"cursor-pointer menu-link " + (kindI === kind ? "active" : "")}
                                        >
                                            {kindI}
                                        </span>
                                    </div>
                                ))
                            )}
                        </div>
                        */}
                    </div>

                </div>
            ) : (
                <>-</>
            )}
        </>
    );
}

export default Events;
